// extracted by mini-css-extract-plugin
export default {"summaryInfo":"Summary_summaryInfo__T82G6"};